<template>
  <div class="shipments-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $t('shipments.sidebar.shipments') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="shipmentsShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'ShipmentsHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            shipmentsShortcuts: [
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.shipmentsTitle'),
                    tableElements: [
                        {
                            action: this.$t('-'),
                            shortcuts: [
                                { key: '-' }
                            ],
                            voiceCommand: this.$t('-')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
